import { useQuery } from '@apollo/client';

import { updateUser } from 'helpers/auth';

import { OnboardingUserDocument } from '../graphql/queries/onboardingUser.gql';

/**
 * Fetches the user profile (used as a prop for legacy onboarding pages)
 * and updates the localStorage with the values once they are loaded.
 */
const useOnboardingUser = () => {
  const userQuery = useQuery(OnboardingUserDocument, {
    onCompleted: (data) =>
      updateUser({
        email: data.viewer.profile.email ?? undefined,
        phone: data.viewer.profile.phone ?? undefined,
        zip: data.viewer.profile.zip ?? undefined,
      }),
    onError: (error) => {
      throw error;
    },
  });

  return userQuery;
};

export default useOnboardingUser;
